import {
  IResourceComponentsProps,
  useExport,
  useGetIdentity,
  useNavigation,
  useShow,
  useDelete,
  useUpdate,
  useUpdateMany,
  useCreateMany,
  useNotification,
} from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  ShowButton,
  Typography,
  ImportButton,
  useImport,
  Popconfirm,
  Button,
  Alert,
  notification,
  Input,
  Divider,
  useTable,
  Form,
  Tooltip,
  Icon,
  Switch,
} from '@pankod/refine-antd'

import '../../styles/custom.css'

import dayjs from 'dayjs'
import moment from 'moment'
import Permissions from 'permissions'
import { CSVLink } from 'react-csv'
import { useUserContext } from 'context/user'

import { useState, useEffect } from 'react'
import { IProduct, ITestEvent } from 'interfaces'
import { CreateTestEvent } from './create'
import { EditTestEvent } from './edit'
import testEventMetaData from 'metadata/test_events'

import { exportToExcel } from 'exportToExcel'
import { CreateEvaluationRequest } from 'pages/evaluation_requests'
import { testEventTemplateFormat } from 'helpers/import_template_format/importTemplate'

const { PlusOutlined, ExportOutlined } = Icons
const { Text, Link } = Typography

type Permission = {
  granted?: boolean
}
export interface ITestEventS {
  name: string
  description: string
  product_id: string
  product: IProduct
  mode_of_exam: string
  location: string
  slots: object
  restrictions: string
  created_by: string
  slots_details: string
}

export const TestEventsList: React.FC<IResourceComponentsProps> = () => {
  const { userRole, userLastSearch, updateUserLastSearch } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [uploadAlert, setUploadAlert] = useState<boolean>(false)
  const [refreshStatus, setRefreshStatus] = useState<boolean>(false)
  const [hasPagination, setHasPagination] = useState<any>(true)
  const [testEvent, setTestEvent] = useState<ITestEvent | undefined>(undefined)
  const [exportData, setExportData] = useState<any[]>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const { data: user } = useGetIdentity()
  const { mutate: updateStatus } = useUpdate()

  const { sorter, tableQueryResult, setFilters, searchFormProps, tableProps } = useTable<ITestEvent>({
    initialSorter: [{ field: 'test_event_id', order: 'desc' }],
    hasPagination,
    // permanentSorter: [
    //   {
    //     field: 'test_event_id',
    //     order: 'desc',
    //   },
    // ],

    metaData: testEventMetaData,
    onSearch(data: any) {
      const searchName = data?.name
      updateUserLastSearch('test_events', searchName || '')
      return [{ field: 'name', operator: 'contains', value: `%${searchName}%` }]
    },
    queryOptions: { enabled: !!window.location.href.includes('test_events') },
  })
  const { show, push } = useNavigation()
  const {
    modalProps: createEvaluationModalProps,
    formProps: createEvaluationFormProps,
    show: createEvaluationModalShow,
  } = useModalForm({ resource: 'evaluation_requests', action: 'create' })

  let listOfTestEvents: any = [] // test events for upload;
  let oneTestEvent: any = { name: '', description: '', product_id: '', mode_of_exam: '', location: '', restrictions: '', created_by: '', slots: [] }

  let slotData: any = { id: '', slots: {} }
  let newSlotData: any = { test_track_id: '', list_of_slots: [] }
  let listOfSlots: any = []
  let count = 0
  let lastTestTrack = ''
  let errorNew = ''

  const { mutate: createTestEvents } = useCreateMany<ITestEvent>()

  ///------------------for uploading multiple test events and mutliple test tracks for multiple test events----------------------
  const importProps = useImport({
    mapData: item => {
      if (item.name && item.name !== '' && item.product_id && item.product_id !== '') {
        //creating an single event
        oneTestEvent['name'] = item?.name.trim()
        oneTestEvent['description'] = item?.description
        oneTestEvent['product_id'] = item?.product_id
        oneTestEvent['mode_of_exam'] = item?.mode_of_exam === '' ? 'online' : item?.mode_of_exam
        oneTestEvent['location'] = item?.location === '' ? 'online' : item?.location
        oneTestEvent['restrictions'] = item?.restrictions === '' ? 'none' : item?.restrictions
        oneTestEvent['created_by'] = user?.id

        //each slot include list_of_slots and test_track_id
        //creating slots based on test_track
        if (item.test_tracks && item.test_tracks !== '') {
          try {
            //adding test_track id to slot
            newSlotData['test_track_id'] = item?.test_tracks
            if (item?.dates !== undefined && item?.dates.length > 0) {
              let givenDate = dayjs(item?.dates)
              const dateISO = givenDate.toISOString()
              //adding date to list_of_slots in test_track
              const startTime = dayjs(`${dayjs().format('YYYY-MM-DD')}T${item?.start_time}`).toISOString()
              const endTime = dayjs(`${dayjs().format('YYYY-MM-DD')}T${item?.end_time}`).toISOString()
              newSlotData['list_of_slots'].push({ date: dateISO, end_time: endTime, start_time: startTime })
            }
            //same name test event present or not ?
            const isTestEventUploaded = listOfTestEvents.findIndex((item: any) => item.name === oneTestEvent.name)
            //checking test event is there or not?
            if (isTestEventUploaded === -1) {
              //if its not present then pushing the slot data to test event
              //and push the test event to list of test events
              oneTestEvent['slots'].push(newSlotData)
              listOfTestEvents.push(oneTestEvent)
            } else {
              //if its there checking same test track is presented or not
              const isSameSlotIndex = listOfTestEvents[isTestEventUploaded]['slots'].findIndex((slot: any) => slot.test_track_id === item.test_tracks)
              //if its not presented then updating
              if (isSameSlotIndex === -1) {
                listOfTestEvents[isTestEventUploaded]['slots'].push(newSlotData)
              } else {
                //if test track already presented on test event then creating an error message
                errorNew = `found same  test tracks on ${item.name} event`
              }
            }
            //making oneTestEvent and newSlotData as same as initial value
            oneTestEvent = { name: '', description: '', product_id: '', mode_of_exam: '', location: '', restrictions: '', created_by: '', slots: [] }
            newSlotData = { test_track_id: '', list_of_slots: [] }
          } catch (e: any) {
            console.log(e, 'error is this')
            errorNew = 'Error occured'
          }
        } else {
          console.log('item missing...')
          oneTestEvent = { name: '', description: '', product_id: '', mode_of_exam: '', location: '', restrictions: '', created_by: '', slots: [] }
          newSlotData = { test_track_id: '', list_of_slots: [] }
          errorNew = 'Test Track is missing'
        }
      }
    },

    paparseOptions: { skipEmptyLines: false },

    onFinish: () => {
      // trigger upload command and reset
      if (errorNew.length !== 0) {
        notification.error({
          message: 'Error Occured',
          description: errorNew !== '' && errorNew !== 'Error occured' ? errorNew : `Please provide a proper csv format data.`,
        })
      } else {
        createTestEvents(
          { resource: 'test_events', values: listOfTestEvents },
          {
            onError: response => {
              listOfTestEvents = []
              notification.error({ message: 'Error Occured', description: 'Test Events could not be uploaded' })
            },
            onSuccess: response => {
              if (response.data.length > 0) {
                listOfTestEvents = []
                // setUploadAlert(true)

                notification.success({ message: 'Successful', description: 'Uploaded test events' })
              } else {
                notification.error({ message: 'Error Occured', description: 'Test Events could not be uploaded' })
              }
            },
          }
        )
      }

      listOfTestEvents = []
      oneTestEvent = { name: '', description: '', product_id: '', mode_of_exam: '', location: '', restrictions: '', created_by: '', slots: [] }
      slotData = { id: '', slots: {} }
      listOfSlots = []
      count = 0
      lastTestTrack = ''
    },
  })

  const {
    formProps,
    modalProps,
    show: createShow,
  } = useModalForm({
    resource: 'test_events',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: closeEditModal,
  } = useModalForm<ITestEvent>({
    resource: 'test_events',
    action: 'edit',
    metaData: testEventMetaData,
  })

  const { triggerExport, isLoading } = useExport<ITestEvent>()

  const { mutate: deleteEvent, error: deleteTestEventError } = useDelete()

  const handleExport = () => {
    exportToExcel(exportData, `test_events_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }

  const hideDeleteButton = (record: ITestEvent): boolean => {
    const { papers: p, paper_requests: pr, assigned_papers: as } = record
    if (p !== undefined && pr !== undefined && as !== undefined) {
      const shouldHide = p.length > 0 || pr.length > 0 || as.length > 0
      return shouldHide
    }
    return false
  }

  // const onChange = (page: number, pageSize?: any): void => {
  //   setCurrent(page)
  // }

  // const searchByName = (value: any) => {
  //   setHasPagination(false)
  //   setFilters([
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `%${value}%`,
  //     },
  //   ])
  // }

  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('test_events'))
      setCreatePermission(Permissions.can(userRole).createAny('test_events'))
      setEditPermission(Permissions.can(userRole).updateAny('test_events'))
      setDeletePermission(Permissions.can(userRole).deleteAny('test_events'))
    }
    if (userLastSearch?.test_events) {
      searchFormProps.form?.setFieldsValue({
        name: userLastSearch.test_events,
      })
      searchFormProps.form?.submit()
    }
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    console.log(readPermission, 'readpermission')
  }, [readPermission])

  // useEffect(() => {
  //   createEvaluationModalShow()
  // }, [testEvent])
  const csvData = [testEventTemplateFormat.map(item => item.toString())]
  return (
    <List
      pageHeaderProps={{
        extra: [
          <div>
            <div>
              <ImportButton {...importProps} />
              <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
                <CSVLink key="export" data={csvData} filename={`Test_Event_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
                  <ExportOutlined /> Download Import Format
                </CSVLink>
              </Button>
            </div>

            <div style={{ marginTop: '5px' }}>
              <Button
                disabled={!(exportData?.length > 0)}
                icon={<Icons.ExportOutlined />}
                type="primary"
                onClick={() => {
                  handleExport()
                }}
                style={{ marginRight: '5px' }}
              >
                Export
              </Button>

              <RefreshButton
                className={refreshStatus ? '' : 'refresh-button-item'}
                loading={refreshStatus}
                onClick={() => {
                  setRefreshStatus(true)
                  tableQueryResult?.refetch().then(() => setRefreshStatus(false))
                }}
              />
            </div>
          </div>,

          // <Button
          //   disabled={!(exportData?.length > 0)}
          //   icon={<Icons.ExportOutlined />}
          //   type="primary"
          //   onClick={() => {
          //     handleExport()
          //   }}
          // >
          //   Export
          // </Button>,

          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          // <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          // <RefreshButton
          //   className={refreshStatus ? '' : 'refresh-button-item'}
          //   loading={refreshStatus}
          //   onClick={() => {
          //     setRefreshStatus(true)
          //     tableQueryResult?.refetch().then(() => setRefreshStatus(false))
          //   }}
          // />,

          // <CreateButton
          //   type="primary"
          //   icon={<PlusOutlined />}
          //   onClick={() => {
          //     createShow()
          //   }}
          // />,
        ],
      }}
    >
      {/* {uploadAlert && (
        <Alert
          style={{ position: 'absolute', zIndex: '5', minWidth: '300px', top: 0, right: 0 }}
          message="Sucessful"
          description="events uploaded"
          type="success"
          closable
          showIcon
          onClose={() => setUploadAlert(false)}
        />
      )} */}
      {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="name">
            <Input placeholder="Search by Name" />
          </Form.Item>
          <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
          <Button
            onClick={() => {
              searchFormProps?.form?.setFieldsValue({ name: '' })
              searchFormProps.form?.submit()
            }}
          >
            Clear
          </Button>
        </Space>
      </Form>
      <Divider />
      <Table
        {...tableProps}
        dataSource={tableQueryResult?.data?.data}
        rowKey="id"
        size="small"
        // pagination={{
        //   total: tableQueryResult?.data?.total,
        //   onChange,
        // }}
        rowSelection={{
          onChange(selectedRowKeys, selectedRows, info) {
            const data = selectedRows?.map(testEvent => ({ id: testEvent?.test_event_id, test_event_id: testEvent?.id, name: testEvent?.name }))
            setExportData(data)
            setSelectedRowKeys(selectedRowKeys)
          },
          selectedRowKeys,
          getCheckboxProps: (record: ITestEvent) => ({
            disabled: record.status === false,
          }),
        }}
        rowClassName={record => (record.status === false ? 'disabled-row' : '')}
      >
        <Table.Column
          dataIndex="name"
          title="Name"
          render={(_, record: any) => (
            <Space size={0}>
              <ShowButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                disabled={record.status === false}
                onClick={() => {
                  show('test_events', record.id)
                }}
              >
                <Text
                  style={{
                    width: 200,
                    textAlign: 'left',
                    color: record.status === false ? 'inherit' : '#6659FF',
                    cursor: record.status === false ? 'not-allowed' : 'pointer',
                  }}
                  ellipsis={{ tooltip: record?.name }}
                >
                  #{record?.test_event_id} {record?.name}
                </Text>
              </ShowButton>
              {/* Kept outside ShowButton: the name itself is a navigation link, so selecting
                  the truncated text is impossible — a click navigates instead of selecting. */}
              <Text copyable={{ text: record?.name, tooltips: ['Copy name', 'Copied'] }} />
            </Space>
          )}
        />
        <Table.Column dataIndex="mode_of_exam" title="Mode Of Exam" />
        <Table.Column dataIndex="location" title="Location" />
        <Table.Column<ITestEvent> dataIndex="product_id" render={(_, record) => record?.product?.name} title="Product" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={(value, record: any) => (
            <span style={{
              color: record.status === false ? '#bfbfbf' : 'inherit',
              pointerEvents: record.status === false ? 'none' : 'auto',
              opacity: record.status === false ? 0.5 : 1,
            }}>
              <DateField value={value} format="LLL" />
            </span>
          )}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        {userRole === 'admin' || userRole === 'productmanager' && <Table.Column
          dataIndex="status"
          title="Cancel Event"
          render={(value: boolean, record: ITestEvent) => (
            <Switch
              checked={!value}
              className="cancel-switch"
              onChange={checked => {
                updateStatus({
                  resource: 'test_events',
                  id: record.id,
                  values: {
                    status: !checked,
                  },
                  mutationMode: 'optimistic',
                })
              }}
            />
          )}
        />}

        <Table.Column<ITestEvent>
          title="Actions"
          dataIndex="actions"
          width={4}
          render={(_, record) => (
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
              {userRole === 'admin' || (userRole === 'productmanager' && record.created_by === user?.id) ? (
                <>
                  <Button
                    size="small"
                    type="link"
                    icon={<Icons.EditOutlined />}
                    disabled={record.status === false}
                    onClick={() => editShow(record.id)}
                  />
                  <Popconfirm
                    title="Are you sure ?"
                    disabled={record.status === false}
                    onConfirm={() =>
                      deleteEvent(
                        { resource: 'test_events', id: record?.id },
                        {
                          onError: (error, variables, context) => {
                            console.log('error:', error, 'variables:', variables)
                          },
                        }
                      )
                    }
                  >
                    <Button
                      type="link"
                      icon={<Icons.DeleteOutlined />}
                      danger
                      hidden={hideDeleteButton(record)}
                      disabled={record.status === false}
                    />
                  </Popconfirm>
                </>
              ) : null}

              {/* <DeleteButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                onErrorCapture={err => {
                  console.log('error logged : ', err)
                }}
              /> */}
              {userRole === 'deliverymanager' ? (
                <Tooltip title="Create Evaluation Request" placement="left">
                  <Button
                    icon={<Icons.DiffOutlined />}
                    itemID={record?.id}
                    value={record?.id}
                    size="small"
                    type="primary"
                    disabled={record.status === false}
                    onClick={() => {
                      setTestEvent(record)
                      createEvaluationModalShow()
                    }}
                  />
                </Tooltip>
              ) : null}
            </Space>
          )}
        />
      </Table>
      {/* <CreateTestEvent modalProps={modalProps} formProps={formProps} /> */}
      <CreateEvaluationRequest modalProps={createEvaluationModalProps} formProps={createEvaluationFormProps} record={testEvent} />
      <EditTestEvent modalProps={editModalProps} formProps={editFormProps} close={closeEditModal} />
    </List>
  )
}
